import { Identificator } from './custom-types';
import { ApplicationCode } from '../enums/application_code';
import { ApplicationUtils } from '../utils/application.utils';

export class Application {
  id!: Identificator | null;
  grupa!: string | null;
  kodTech!: string | null;
  kod!: ApplicationCode | null;
  nazwa!: string | null;
  czyKorespondencja!: boolean | null;
  obszar!: string | null;

  constructor(
    id: Identificator | null = null,
    grupa: string | null = null,
    kodTech: string | null = null,
    kod: ApplicationCode | null = null,
    nazwa: string | null = null,
    czyKorespondencja: boolean | null = null,
    obszar: string | null = null,
  ) {
    this.id = id;
    this.grupa = grupa;
    this.kodTech = kodTech;
    this.kod = kod;
    this.nazwa = nazwa;
    this.czyKorespondencja = czyKorespondencja;
    this.obszar = obszar;
  }

  static fromDto(data: any): Application {
    const app = new Application();
    app.id = data.id;
    app.grupa = data.grupa;
    app.kodTech = data.kodTech;
    app.kod = data.kod;
    app.nazwa = data.nazwa;
    app.czyKorespondencja = data.czyKorespondencja;
    app.obszar = data.obszar;
    return app;
  }

  czyJednostkaWojewodzka(): boolean {
    return (
      this.grupa == 'ON' ||
      this.kod == ApplicationCode.RKZ_6 ||
      this.kod == ApplicationCode.RKZ_7 ||
      this.kod == ApplicationCode.PPW
    );
  }

  isFromZus(): boolean {
    return this.kod != null ? ApplicationUtils.isFromZus(this.kod) : false;
  }

  getIcon(): string {
    switch (this.kod) {
      case ApplicationCode.AWD: {
        return 'assets/images/cards/AwD-64x64@2x.png';
      }
      case ApplicationCode.AWP: {
        return 'assets/images/cards/AwP-64x64@2x.png';
      }
      case ApplicationCode.AWZ: {
        return 'assets/images/cards/AwZ-64x64@2x.png';
      }
      case ApplicationCode.DS_R: {
        return 'assets/images/cards/DS-R-64x64@2x.png';
      }
      case ApplicationCode.FA_1: {
        return 'assets/images/cards/FA-1-64x64@2x.png';
      }
      case ApplicationCode.KDR: {
        return 'assets/images/cards/KDR-64x64@2x.png';
      }
      case ApplicationCode.PPW: {
        return 'assets/images/cards/PPW-64x64@2x.png';
      }
      case ApplicationCode.SR_1: {
        return 'assets/images/cards/SR-1-64x64@2x.png';
      }
      case ApplicationCode.SR_2: {
        return 'assets/images/cards/SR-2-64x64@2x.png';
      }
      case ApplicationCode.SR_3: {
        return 'assets/images/cards/SR-3-64x64@2x.png';
      }
      case ApplicationCode.SR_7: {
        return 'assets/images/cards/SR-7-64x64@2x.png';
      }
      case ApplicationCode.SW_R: {
        return 'assets/images/cards/SW-R-64x64@2x.png';
      }
      case ApplicationCode.SWN: {
        return 'assets/images/cards/SWN-64x64@2x.png';
      }
    }
    return '';
  }
}
